import {Options} from "highcharts";
import {registerPlugin} from "surveylabJsAssets/chart/charts";
import AbstractChart from "surveylabJsAssets/chart/plugin/abstract-chart";

export class SectorRanking extends AbstractChart {

    protected allChartOptions(): Options {
        const options: Options = {
            chart: {
                type: 'bar',
                width: 680,
                marginBottom: 75,
                style: {
                    overflow: 'visible'
                }
            },
            plotOptions: {
                bar: {
                    borderWidth: 0
                }
            },
            xAxis: {
                tickWidth: 1,
                tickLength: 10,
                labels: {
                    align: 'left',
                    reserveSpace: true,
                    formatter: function () {
                        return '<div class="sector-ranking-label">' +
                            '<span class="ranking-number">' + this.value[0] + '</span>' +
                            '<span>' + this.value[1] + '</span>' +
                            '</div>';
                    }
                },
            },
            yAxis: {
                gridLineWidth: 0,
                min: -2,
                max: 2,
                tickInterval: 1,
                labels: {
                    align: 'center',
                    formatter: function () {
                        return $('.sector-ranking-chart-container').data("y-axis-labels")[this.value];
                    }
                }
            }
        }

        return super.mergeOptions(super.allChartOptions(), options);
    }
}

export default function () {
    registerPlugin(SectorRanking)
}